var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 170,
    viewBox: "0 0 261 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4998 35.7C78.4998 35.7 75.5998 8.09998 45.0998 8.09998C14.5998 8.09998 0.899815 28 1.49982 45.9C2.19982 65.1 10.9998 78.2 16.5998 86.1C21.5998 93.1 26.3998 98.7 34.7998 101.6C40.6998 103.6 44.0998 117.1 46.4998 121C48.8998 124.9 53.6998 130.4 61.9998 129.7C70.1998 128.9 78.6998 121.5 78.4998 109.4C78.2998 99 75.1998 95.5 75.1998 95.5",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7002 55.1C58.7002 55.1 69.4002 46.9 64.0002 31.9C58.6002 16.9 38.6002 20.1 30.1002 22.2C22.0002 24.2 11.7002 34.8 11.7002 45C11.7002 55.2 14.1002 69.2 28.6002 84.7",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7999 35.1C64.7999 35.1 43.7999 30.4 34.8999 41.2C27.7999 49.7 30.9999 60.5 36.8999 68.1C40.1999 72.4 48.3999 82.5 48.3999 93.3C48.3999 104.1 58.9999 103.4 61.5999 103C64.0999 102.6 67.4999 100.4 67.0999 94.7C66.7999 90.4 62.2999 88.4 62.2999 88.4C62.2999 88.4 57.1999 86.7 57.2999 82.1C57.3999 75.2 64.6999 77.1 65.3999 72.5C65.6999 70.3 65.4999 64.6 65.4999 64.6",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.1 35.7C182.1 35.7 185 8.09998 215.5 8.09998C246 8.09998 259.7 28 259.1 45.9C258.4 65.1 249.6 78.2 244 86.1C239 93.1 234.2 98.7 225.8 101.6C219.9 103.6 216.5 117.1 214.1 121C211.7 124.9 206.9 130.4 198.6 129.7C190.4 128.9 181.9 121.5 182.1 109.4C182.1 109.1 182.1 108.8 182.1 108.6C182.5 98.9 185.4 95.5 185.4 95.5",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202 55.1C202 55.1 191.3 46.9 196.7 31.9C202 16.9 222.1 20.1 230.6 22.2C238.7 24.2 249 34.8 249 45C249 55.2 246.6 69.2 232.1 84.7",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.8 35.1C195.8 35.1 216.8 30.4 225.7 41.2C232.8 49.7 229.6 60.5 223.7 68.1C220.4 72.4 212.2 82.5 212.2 93.3C212.2 104.1 201.6 103.4 199 103C196.5 102.6 193.1 100.4 193.5 94.7C193.8 90.4 198.3 88.4 198.3 88.4C198.3 88.4 203.4 86.7 203.3 82.1C203.2 75.2 195.9 77.1 195.2 72.5C194.9 70.3 195.1 64.8 195.1 64.8",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1001 24.3C92.8001 10.4 109.8 1.80001 129.2 1.50001C148.4 1.20001 167.1 9.90001 179.3 23.2",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.8 122.8C161.2 122.8 185.8 98.2 185.8 67.8C185.8 37.4 161.2 12.8 130.8 12.8C100.4 12.8 75.7998 37.4 75.7998 67.8C75.7998 98.2 100.5 122.8 130.8 122.8Z",
    stroke: "#000000",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.8 110.4C154.328 110.4 173.4 91.3273 173.4 67.8C173.4 44.2727 154.328 25.2 130.8 25.2C107.273 25.2 88.2002 44.2727 88.2002 67.8C88.2002 91.3273 107.273 110.4 130.8 110.4Z",
    stroke: "#000000",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.8 98.4C147.7 98.4 161.4 84.6999 161.4 67.8C161.4 50.9001 147.7 37.2 130.8 37.2C113.9 37.2 100.2 50.9001 100.2 67.8C100.2 84.6999 113.9 98.4 130.8 98.4Z",
    stroke: "#000000",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.8 85.9C140.8 85.9 148.9 77.8 148.9 67.8C148.9 57.8 140.8 49.7 130.8 49.7C120.8 49.7 112.7 57.8 112.7 67.8C112.8 77.8 120.8 85.9 130.8 85.9Z",
    stroke: "#000000",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.3 131.8C115.5 135 114.4 136.8 110.9 139.6C107.1 142.3 103 143.8 98.3999 143.8C95.1999 144 87.0999 144 86.1999 144.3C85.3999 144.6 84.9999 145.2 85.1999 146.1C85.6999 148.6 86.1 151.2 86.5 153.7C87 156.9 87.3999 160.2 86.6999 163.4C85.8999 166.9 83.9999 168.4 79.7999 167.7C76.0999 167.1 73.4999 164.8 71.8999 161.6C69.8999 157.7 68.3999 153.6 68.6999 149C68.9999 144.4 71.0999 141.2 75.3999 139.4C76.4999 138.9 76.9999 138.5 76.7999 137.1C76.4999 135.4 76.4999 133.6 76.3999 131.9C76.3999 131.1 76.3999 130.3 76.5999 129.5C77.2999 127 79.2 125.9 82 126.4C82.6 126.5 83.1 126.6 84 126.8C87.5 127.9 90.9999 129.5 96.0999 130.2C98.0999 130.4 102.7 130.2 105.8 127.9",
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.1 131.8C144.9 135 146 136.8 149.5 139.6C153.3 142.3 157.4 143.8 162 143.8C165.2 144 173.3 144 174.2 144.3C175 144.6 175.4 145.2 175.2 146.1C174.7 148.6 174.3 151.2 173.9 153.7C173.4 156.9 173 160.2 173.7 163.4C174.5 166.9 176.4 168.4 180.6 167.7C184.3 167.1 186.9 164.8 188.5 161.6C190.5 157.7 192 153.6 191.7 149C191.4 144.4 189.3 141.2 185 139.4C183.9 138.9 183.4 138.5 183.6 137.1C183.9 135.4 183.9 133.6 184 131.9C184 131.1 184 130.3 183.8 129.5C183.1 127 181.2 125.9 178.4 126.4C177.8 126.5 177.3 126.6 176.4 126.8C172.9 127.9 169.4 129.5 164.3 130.2C162.3 130.4 157.7 130.2 154.6 127.9",
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.8 75.5C135.1 75.5 138.5 72.1 138.5 67.8C138.5 63.5 135.1 60.1 130.8 60.1C126.5 60.1 123.1 63.5 123.1 67.8C123.1 72.1 126.6 75.5 130.8 75.5Z",
    stroke: "#000000",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_51_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 170
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 0H0V169.3H260.6V0Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_51_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 113.4C175.4 114 174.8 114.6 174.2 115.2C162.9 125.7 148 132.2 131.5 132.5C113.1 132.8 96.2998 125.3 84.2998 113",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/Logo3.62b0db30df890c33e0427536fe3ad0ed.svg";
export { ForwardRef as ReactComponent };